<template>
  <div>
    <v-layout row style="align-items: center;">
      <v-menu v-if="!disabled" full-width offset-y :close-on-content-click="false" v-model="dateMenuVisible" bottom>
        <v-text-field
          slot="activator"
          :label="label"
          :value="formattedDate"
          :readOnly="true"
          :append-outer-icon="outerIcon"
          :append-outer-icon-cb="handleReset"
        />
        <v-card>
          <v-card-text>
            <v-date-picker
              v-model="proxyDate"
              no-title
              :min="minDatetime"
              :max="maxDatetime"
            />
            <!-- todo(egor): add time select -->
          </v-card-text>
        </v-card>
      </v-menu>

      <div v-else>
        <v-text-field
          :label="label"
          :value="formattedDate"
          :readOnly="true"
          :disabled="true"
        />
      </div>

      <v-btn v-if="showNow" small icon @click="setNowDate">
        <!-- todo(egor): move in menu -->
        now
      </v-btn>

    </v-layout>
    <div class="v-text-field__details" v-if="errorMessage">
      <div class="v-messages theme--light error--text">
        <div class="v-messages__wrapper">
          <div class="v-messages__message">{{errorMessage}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import DateWithMinutes from '../Filters/DateWithMinutes.js'
    import NoEmpty from '../Filters/NoEmpty.js'
    import {FULL_DATE_FORMAT} from '../../helpers/date'
    import moment from 'moment'

    export default {
        name: 'date-time-input',
        filters: {
            DateWithMinutes,
            NoEmpty
        },
        props: {
            value: {
                type: String,
            },
            label: {
                type: String,
            },
            minDatetime: {
                type: String,
            },
            maxDatetime: {
                type: String,
            },
            showNow: {
                type: Boolean,
                default: true
            },
            required: {
                type: false,
                default: false,
            },
            disabled: {
                type: Boolean,
                default: false
            },
            valuePostProcessor: { // process value before set
                type: Function,
                default: value => value
            }
        },
        data() {
            return {
                dateMenuVisible: false,
                timeMenuVisible: false,
                date: null, // calculate using props
                time: null,
            }
        },
        computed: {
            formattedDate() {
                return NoEmpty(DateWithMinutes(this.value));
            },
            proxyDate: {
                get() {
                    if (!this.value) {
                        return null
                    }
                    return moment(this.value).format('YYYY-MM-DD')
                },
                set(newValue) {
                    let currentValue = this.value;
                    if (!currentValue) {
                        currentValue = new Date(0).toISOString()
                    }

                    let currentValueAsMoment = moment(currentValue);
                    let newValueMoment = moment(newValue, "YYYY-MM-DD");

                    let result = newValueMoment;

                    // let result = currentValueAsMoment
                    //     .year(newValueMoment.year())
                    //     .month(newValueMoment.month())
                    //     .day(newValueMoment.day());

                    this.emitInput(result.utc().format(FULL_DATE_FORMAT));
                    this.dateMenuVisible = false;
                }
            },
            proxyTime: {
                get() {
                    if (!this.value) {
                        return null
                    }
                    return moment(this.value).format('HH:mm:ss')
                },
                set(newValue) {
                    let currentValue = this.value;
                    if (!currentValue) {
                        currentValue = new Date().toISOString()
                    }

                    let currentValueAsMoment = moment(currentValue);
                    let newValueMoment = moment(newValue, "HH-mm");

                    let result = currentValueAsMoment
                        .hour(newValueMoment.hour())
                        .minute(newValueMoment.minute());

                    this.emitInput(result.utc().format(FULL_DATE_FORMAT))
                }
            },
            errorMessage() {
                if (this.required && !this.value) {
                    return 'Can\'t be empty'
                }

                return null
            },
            outerIcon() {
                if (this.value && !this.required) {
                    return 'fas fa-times'
                }

                return null
            }
        },
        methods: {
            setNowDate() {
                this.emitInput(new Date().toISOString())
            },
            handleReset() {
                this.emitInput(null)
            },
            emitInput(value) {
                const processedValue = this.valuePostProcessor(value);
                this.$emit('input', processedValue)
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/Ui/DateTimeInput.vue